import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../monthlyTradeDataSlice";
import getMonthlyDateData from "../api/getMonthlyDateData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.monthlyTrade;

  const pagedTrades = await dispatch(getMonthlyDateData(user, filter));

  dispatch(setData(pagedTrades || []));
};
